export type PaginationRuleModel = {
  brand_id: number,
  cache_key: number,
  default?: boolean,
  group_items_by?: string,
  id: number,
  placement_direction?: string,
  sort_items_by?: string[],
  start_page?: string,
  title: string,
}

const state = {
  id: null,
  brand_id: undefined,
  default: false,
  group_items_by: '',
  placement_direction: '',
  sort_items_by: [],
  start_page: '',
  title: '',
}

export const requiredFields = [
  { key: 'brand_id' },
  {
    key: 'sort_items_by',
    validation: (value: string[]) => !!value.length,
    invalidMessage: 'Required',
  },
  { key: 'title' },
]

export default state
